import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JoinedUser from '../JoinedUser';
import './style.scss';

export default class JoinedUserList extends Component {
  renderJoinedUserList = (joinedUsers, status) => {
    let row = [];
    let res = [];
    const joinedUserIdList = joinedUsers.map(joinedUser => joinedUser.objectId);
    
    joinedUsers.forEach((user, i) => {
      if (i % 2 === 0 && i !== 0) {
        res.push(<div key={i - 1} className="row">{row}</div>);
        row = [];
      }
      row.push(
        <JoinedUser 
          key={user.objectId} 
          eventId={this.props.eventId} 
          joinedUser={user} status={status} 
          openPopupViewStudentProfile={() => this.props.openPopupViewStudentProfile(i, joinedUserIdList, status)} 
        />
      );
  
      if (i === joinedUsers.length - 1) {
        res.push(<div key={i} className="row">{row}</div>);
      }
    });

    return res;
  }

  render() {
    const { joinedUsers = [], status } = this.props;
    if (joinedUsers.length === 0) {
      return null;
    }
    
    return (
      <div id="joined-user-list">
        <div id="title">{status === 'joined' ? '参加確定' : '選ばなかった学生'}</div>
        {this.renderJoinedUserList(joinedUsers, status)}
      </div>
    );
  }
}

JoinedUserList.propTypes = {
  eventId: PropTypes.string,
  status: PropTypes.string,
  joinedUsers: PropTypes.array,
  openPopupViewStudentProfile: PropTypes.func
};
